export default {
  pickup: 'Afhentning',
  delivery: 'Levering',
  ongoing_order: 'Igangværende ordre',
  view_more: 'Tryk for at se detaljer',
  status: {
    rejected: {
      title: 'Ordre afvist',
      description: 'Tryk for at se detaljer',
    },
    created: {
      description: 'Ordre modtaget',
    },
    reviewed: {
      description: 'Din ordre er set',
    },
  },
  order_type: {
    pickup: 'afhentning',
    delivery: 'levering',
  },
  order_status_toast: {
    order_reviewed: '#{{number}} Din ordre er set',
    order_confirmed: '#{{number}} Bekræftet tidspunkt {{time}}',
    order_preparation_up_time_changed: '#{{number}} Tidspunkt for {{type}} ændret til {{time}}',
    order_preparing: 'Din ordre #{{number}} bliver tilberedt',
    order_rejected: '#{{number}} ordre afvist',
  },
  error_messages: {
    failed_to_load: 'Noget gik galt. Prøv igen.',
  },
};
